document.addEventListener('DOMContentLoaded', function() {
  
  // Function to run the calculation
  function updatePrice(event) {
    // 1. Get the current quantity
    const input = event.target;
    // If the input is empty or invalid, assume 1
    const quantity = parseInt(input.value) || 1; 

    // 2. Find the product container to ensure we target the right price
    const productSection = input.closest('.product');
    if (!productSection) return;

    // 3. Find the active price element (Regular or Sale)
    // We look for the one that is NOT hidden
    const priceContainer = productSection.querySelector('.price__regular:not(.hidden) .price-item--regular, .price__sale:not(.hidden) .price-item--sale');
    
    if (!priceContainer) return;

    // 4. Get the Base Price from our new data attribute
    // We check for 'data-sale-price' or 'data-regular-price'
    let basePrice = parseFloat(priceContainer.getAttribute('data-sale-price'));
    
    // If it's not on sale, grab the regular price attribute
    if (isNaN(basePrice)) {
        basePrice = parseFloat(priceContainer.getAttribute('data-regular-price'));
    }

    // Safety check: if we still can't find a price, stop here
    if (isNaN(basePrice)) return;

    // 5. Calculate Total
    const totalPrice = (basePrice * quantity).toFixed(2);

    // 6. Get the Currency Symbol (by removing numbers from the current text)
    // This keeps your '$', '£', 'Rs.', etc. intact.
    const currentText = priceContainer.innerText;
    const currencySymbol = currentText.replace(/[0-9.,]/g, '').trim();

    // 7. Update the display
    priceContainer.innerText = currencySymbol + ' ' + totalPrice;
  }

  // Add event listeners to all quantity inputs
  const quantityInputs = document.querySelectorAll('.quantity__input');
  
  quantityInputs.forEach(input => {
    input.addEventListener('change', updatePrice);
    input.addEventListener('keyup', updatePrice);
    
    // Also listen to the plus/minus buttons
    const wrapper = input.closest('quantity-input');
    if (wrapper) {
      const buttons = wrapper.querySelectorAll('.quantity__button');
      buttons.forEach(btn => btn.addEventListener('click', () => {
        // Wait 50ms for the input value to update after click
        setTimeout(() => updatePrice({ target: input }), 50); 
      }));
    }
  });
});